import { Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '@app/shared/services/common.service';
import { CommonModule, NgFor } from '@angular/common';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { TabsComponent } from '@app/shared/custom-component/tabs/tabs.component';
import { TabAction } from '@app/shared/custom-component/tabs/tabs.interface';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { debounceTime, Subject, take, takeUntil } from 'rxjs';
import {
  ARCHIVAL_DATE_SEARCH_FIELD,
  BACKGROUND_ADVANCED_SEARCH_FIELDS,
  BOOLEAN_VALUES,
  COMPLAINT_SOURCE,
  LOCK_STATUS,
  LOCK_STATUS_CODES,
  QUEUE_CONSTANTS,
  queues,
  QUEUES_ADVANCED_SEARCH_FIELDS,
  YES_NO
} from '@app/shared/constants/queue.constants';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { AlertService } from '@core/services/alert.service';
import { QueueStatusFilterDirective } from '@app/shared/directives/queue-status-filter.directive';
import { AssignmentSessionData, errorMessages, modalButtonTitles, ModalConfig, modalContent, modalHeading } from '@app/shared/constants/modal.model';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { InternalNotesModalComponent } from '@app/shared/custom-component/internal-notes-modal/internal-notes-modal.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DynamicSearchFormComponent } from '@app/dynamic-search-form/dynamic-search-form.component';
import { DynamicFieldConfig } from '@app/dynamic-search-form/dynamic-search-form.interface';
import { QueuesService } from './queues.service';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { LocalService } from '@app/@core/services/local.service';
import { AppService } from '@app/@core/services/app.service';
import { LOOKUP_USER_RETURN_URL_KEY } from '@app/shared/services/application-open-from-grid.service';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';
import { ComplaintFormService } from '@app/app-login/complaint-form/complaint-form.service';
import { FingerprintPortalService } from '@app/fingerprint-portal/fingerprint-portal.service';
import {
  admin,
  analyst,
  background,
  DashboardAdmin,
  deficiency,
  doesNotQualify,
  intake
} from '@app/shared/directives/queue-status-filter.constant';
import { QUEUE_BG_STATUS_KEY_BY_LABEL } from '@app/shared/directives/queues-bg-status.constant';
import { InAppMessageService } from '@app/pages/in-app-message/in-app-message.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { HttpService } from '@app/@core/services/http.service';

@Component({
  selector: 'app-queues',
  templateUrl: './queues.component.html',
  styleUrls: ['./queues.component.scss'],
  standalone: true,
  imports: [CommonModule, DataGridComponent, TabsComponent, NgFor, MaterialUIModule, DynamicSearchFormComponent]
})
export class QueuesComponent implements OnInit, OnDestroy {
  activeSearchFieldCount: number = 0;
  advancedSearchFields: DynamicFieldConfig[];
  isHeaderFilterOpen = false;
  tabs = [];
  activeTab: any = QUEUE_CONSTANTS.DEFAULT_ACTIVE_TAB;
  showColumnChooser: boolean = false;
  allColumns: { key: string; label: string; visible?: boolean; disabled?: boolean }[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  queueData: any[] = [];
  originalQueueData: any[] = [];
  tabActions: TabAction[] = [];
  private destroy$ = new Subject<void>();
  private fetchQueueDataTrigger$ = new Subject<any>();
  applicationData: any;
  Application: boolean = true;
  Complaint: boolean = false;
  private applicationDataLoaded = false;
  private complaintDataLoaded = false;
  lastAdvancedSearchValues: any = null;
  complaintGridData: DataGridVO = new DataGridVO();
  complaintHeaders: any;
  queuesHeaders: any;
  complaintData: any[] = [];
  allComplaintColoumns: { key: string; label: string }[] = [];
  showComplaintColumnChooser: boolean = false;
  visibleComplaintColumns: { [key: string]: boolean } = {};
  dataGridConfig: DataGridVO = new DataGridVO();
  private fetchQueueDataSubscription: any;
  suffixData: any;
  customModal: NgbModalRef;
  customModalConfig: ModalConfig;
  currentUserFullName: any;
  isViewMode: boolean = false;
  suffixList: any;
  @ViewChildren(DynamicSearchFormComponent) searchForms: QueryList<DynamicSearchFormComponent>;
  @ViewChild(DataGridComponent) dataGridComponent!: DataGridComponent;
  showAdvancedSearch = false;
  backgroundCheckList = ['Card Over 1 Year',
    'Information Requested',
    'In process',
    'Issued',
    'Manual',
    'Record Found',
    'Reprint',
    'Resubmission', 'Pending', 'Denied', 'Clear'];
  LICENSE_TYPES: any[] = [];
  filteredLicenseTypes: any[] = [];
  licenseTypeSearchValue: string = '';
  paramMapSubscription: any;
  showComplaintAddButton: boolean = false;
  showComplaintAssign: boolean = false;
  userRoleId: number;
  backgroundQueueFilteredData = ['archive', '=', 'Active'];
  assignToList: any[] = [];
  private complaintMetaLoaded = false;
  private assignToListLoaded = false;
  queueTabPageData: any = null;
  dataGridPageSize = 10;
  dataGridPage = 1;

  private formatEducatorName(item: any): string {
    const firstName = (item?.educator_first_name ?? item?.first_name ?? '').trim();
    const lastName = (item?.educator_last_name ?? item?.last_name ?? '').trim();

    // Use individual fields — first + last only (no middle), preserves compound last names
    if (firstName && lastName) {
      return `${firstName} ${lastName}`;
    }

    // Single field available
    if (firstName || lastName) {
      return firstName || lastName;
    }

    // Fallback: educator_name field only — API returns "First Middle Last(s)"
    // Strip the second word (middle name) when 3+ words present
    if (typeof item?.educator_name === 'string' && item.educator_name.trim()) {
      const parts = item.educator_name.trim().split(/\s+/);
      if (parts.length >= 3) {
        // parts[0] = first, parts[1] = middle (strip it), parts[2+] = last
        return `${parts[0]} ${parts.slice(2).join(' ')}`;
      }
      return parts.join(' ');
    }

    return '';
  }

  private getQueueRules(queueName: string): QueueRule[] {
    switch ((queueName || '').toLowerCase()) {
      case 'intake':
        return intake;
      case 'deficiency':
        return deficiency;
      case 'analyst':
        return analyst;
      case 'doesnotqualify':
        return doesNotQualify;
      case 'admin':
        return admin;
      case 'dashboardadmin':
        return DashboardAdmin;
      case 'background':
        return background;
      default:
        return [];
    }
  }

  // private buildQueueStatusPayload(queueName: string): { is_archived: (boolean | null|undefined)[] | null; } {
  //   const rules = this.getQueueRules(queueName);

  //    const appStatus = Array.from(new Set(rules.map(rule => rule.appStatus).filter(Boolean)));

  //   const bgStatus = Array.from(new Set(
  //     rules
  //       .filter(rule => rule.bgStatus && rule.bgStatus.length > 0)  // Only rules with bgStatus requirements
  //       .flatMap(rule => rule.bgStatus || [])
  //       .filter(Boolean)
  //       .map((status: string) => QUEUE_BG_STATUS_KEY_BY_LABEL[status] || status)
  //   ));

  //   const isAdminQueue = ['admin'].includes((queueName || '').toLowerCase());

  //   return {
  //     [QUEUE_PAYLOAD_PARAMS.isArchived]: isAdminQueue ? [] : [false,null],
  //     // [QUEUE_PAYLOAD_PARAMS.appStatus]: appStatus,
  //     // [QUEUE_PAYLOAD_PARAMS.bgStatus]: bgStatus
  //   };
  // }

  constructor(
    private router: Router,
    private commonService: CommonService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private ngbService: NgbModal,
    private sessionStorage: LocalService,
    private queuesService: QueuesService,
    private myAppService: MyApplicationsService,
    private appService: AppService,
    private complaintFormService: ComplaintFormService,
    private fingerprintService: FingerprintPortalService,
    private cdr: ChangeDetectorRef,
    private inAppMessageService: InAppMessageService,
     private httpService: HttpService,
  ) {
    this.updateDataGridConfig();
    this.initializeTabActions();
    this.setAdvancedSearchFields();
    this.dataGridConfig = DataGridVO.create({
      role: this.activeTab,
      activeTab: this.activeTab,
      customHeaders: this.queuesHeaders,
      data: this.queueData,
      visibleColumns: this.visibleColumns,
      showQueueActions: true,
      disableApplicationClick: false,
      customPageSize: 10,
    });
    this.complaintGridData = DataGridVO.create({
      visibleColumns: this.visibleComplaintColumns,
      showQueueActions: false,
    });

    // Debounce all fetchQueueData triggers
    this.fetchQueueDataTrigger$
      .pipe(debounceTime(100), takeUntil(this.destroy$))
      .subscribe(payload => this._fetchQueueData(payload));
  }
  private initializeTabActions(): void {
    this.tabActions = [
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z" fill="currentColor" />
          </svg>`,
        tooltip: 'Export',
        id: 'queues_button_export',
        action: () => this.downloadExcel()
      },
      {
        icon: `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z" fill="currentColor" />
          </svg>`,
        tooltip: 'Column Chooser',
        id: 'queues_button_columnchooser_btn',
        action: () => this.toggleColumnChooser()
      }
    ];
  }
  private setAdvancedSearchFields(): void {
    let sourceFields;
    if (this.activeTab === 'background') {
      // Exclude archival_date by default; it will be added conditionally below if the column is checked
      sourceFields = [
        ...QUEUES_ADVANCED_SEARCH_FIELDS.filter(f => f.key !== 'license_expiration_date'),
        ...BACKGROUND_ADVANCED_SEARCH_FIELDS.filter(f => f.key !== 'archival_date')
      ];
    } else if (this.activeTab === 'intake' || this.activeTab === 'deficiency' || this.activeTab === 'admin') {
      sourceFields = QUEUES_ADVANCED_SEARCH_FIELDS.filter(f => f.key !== 're_submitted_date' && f.key !== 'license_expiration_date');
      sourceFields = [
        ...sourceFields,
        { key: 're_submitted_date', fieldName: 're_submitted_date', label: 'Resubmitted Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
        { key: 'license_expiration_date', fieldName: 'license_expiration_date', label: 'License Expiration Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false }
      ];
    } else {
      sourceFields = QUEUES_ADVANCED_SEARCH_FIELDS.filter(f => f.key !== 're_submitted_date' && f.key !== 'license_expiration_date');
      sourceFields = [
        ...sourceFields,
        { key: 'license_expiration_date', fieldName: 'license_expiration_date', label: 'License Expiration Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false }
      ];
    }
    this.advancedSearchFields = sourceFields.map(field => {
      const clone = (obj: any): any => {
        if (Array.isArray(obj)) {
          return obj.map(item => clone(item));
        } else if (obj && typeof obj === 'object') {
          const result: any = {};
          for (const key in obj) {
            result[key] = clone(obj[key]);
          }
          return result;
        }
        return obj;
      };
      const mutableField: DynamicFieldConfig = clone(field);
      if (mutableField.validation !== undefined) {
        mutableField.validation = Array.isArray(mutableField.validation)
          ? mutableField.validation.map(v => v as 'required' | 'pattern' | 'numberonly' | 'minlength' | 'maxlength' | 'email' | 'datePattern')
          : undefined;
      }
      const backgroundBooleanDropdowns = [
        'has_suspended_or_revoked_license',
        'has_cert_or_license_revoked',
        'has_disciplinary_action',
        'has_criminal_conviction',
        'has_sexual_offense_arrest',
        'has_child_abuse_substantiated'
      ];
      if (
        mutableField.datatype === 'dropdown' &&
        backgroundBooleanDropdowns.includes(mutableField.key)
      ) {
        mutableField.placeholder = 'Select Response';
        mutableField.options = [...YES_NO];
        mutableField.value = '';
      } else if (mutableField.datatype === 'dropdown' && mutableField.key === 'license_type') {
        mutableField.placeholder = 'Enter License Type';
        mutableField.options = [...this.LICENSE_TYPES.map(t => ({ label: t.value, value: t.key }))];
        mutableField.value = '';
      } else if (mutableField.datatype === 'dropdown') {
        mutableField.placeholder = 'Select Response';
        if (!mutableField.options || !Array.isArray(mutableField.options)) {
          mutableField.options = [];
        }
        mutableField.value = '';
      }
      return mutableField;
    });

    // In the background tab, add archival_date search field only when the archival_date column is checked in column chooser
    if (this.activeTab === 'background' && this.visibleColumns && this.visibleColumns['archival_date']) {
      this.advancedSearchFields.push({ ...ARCHIVAL_DATE_SEARCH_FIELD } as DynamicFieldConfig);
    }
  }
  private toggleColumnChooser(): void {
    this.showColumnChooser = !this.showColumnChooser;
    this.updateDataGridConfig();
  }

  private runWhenBrowserIdle(task: () => void, fallbackDelay = 1000): void {
    if (typeof window !== 'undefined' && typeof (window as any).requestIdleCallback === 'function') {
      (window as any).requestIdleCallback(() => task(), { timeout: fallbackDelay });
      return;
    }
    setTimeout(task, fallbackDelay);
  }

  private loadComplaintSupportData(): void {
    if (!this.assignToListLoaded) {
      this.complaintFormService.getPersonByRole()
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.assignToList = response.data.data;
            this.assignToListLoaded = true;
          }
        });
    }

    if (!this.complaintMetaLoaded) {
      this.commonService.getMetaData(QUEUE_CONSTANTS.COMPLAINT_HEADERS)
        .pipe(take(1), takeUntil(this.destroy$)).subscribe((res: any) => {
          this.complaintHeaders = res.complaintHeaders;
          if (Array.isArray(res.complaintHeaders)) {
            this.allComplaintColoumns = res.complaintHeaders.map((h: any) => ({
              key: h.dataField,
              label: h.caption || h.dataField,
            }));
          }
          if (!this.visibleComplaintColumns) {
            this.visibleComplaintColumns = {};
          }
          this.allComplaintColoumns.forEach(c => {
            if (typeof this.visibleComplaintColumns[c.key] === 'undefined') {
              if (c.key == 'complaint_archival_status') {
                this.visibleComplaintColumns[c.key] = false;
              } else {
                this.visibleComplaintColumns[c.key] = true;
              }
            }
          });
          this.complaintMetaLoaded = true;
        });
    }
  }

  private scheduleBackgroundDeferredLoad(): void {
    this.runWhenBrowserIdle(() => this.loadComplaintSupportData(), 500);

    this.runWhenBrowserIdle(() => {
      if (!this.complaintDataLoaded) {
        this.complaintDataLoaded = true;
        this.extractComplaintData();
      }
    }, 1200);
  }

  ngOnInit(): void {
     sessionStorage.removeItem('userapplicationmode');

    // Subscribe to refresh events from service (e.g., after unlock)
    this.queuesService.refreshQueues$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log('[QUEUES] Refresh triggered by service event');
        this.fetchQueueData();
      });

    // Remove this.fetchQueueData(); to avoid double API call
    this.commonService
      .getMetaData(QUEUE_CONSTANTS.METADATA_TYPE)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.tabs = res.tabs;
      });
    this.queuesService.getLicenseTypes()
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (item: any) => {
          this.LICENSE_TYPES = item?.data || item[0]?.data || [];
          this.filteredLicenseTypes = this.LICENSE_TYPES;
          this.setAdvancedSearchFields();
        },
        error: (err) => {
          console.error('Failed to load license types:', err);
        }
      });

    let lastTab: string | null = null;
    this.paramMapSubscription = this.activatedRoute.paramMap.subscribe(params => {
      const tab = params.get('queueName') || QUEUE_CONSTANTS.DEFAULT_ACTIVE_TAB;
      if (lastTab === null) {
        // Initial load
        this.activeTab = tab;
        this.loadColumnMetadata(this.activeTab);
        this.setAdvancedSearchFields();
        this.initVisibleColumns();
        if (tab === 'background') {
          // Background tab: prioritize Applications, defer Complaints
          this.Application = true;
          this.Complaint = false;
          this.applicationDataLoaded = false;
          this.complaintDataLoaded = false;
          this.fetchQueueData();
        } else {
          this.fetchQueueData();
        }
      } else if (lastTab !== tab) {
        // Tab change
        this.showAdvancedSearch = false;
        this.lastAdvancedSearchValues = null;
        this.activeSearchFieldCount = 0;
        if (this.searchForms && this.searchForms.first) {
          this.searchForms.first.reset();
        }
        this.activeTab = tab;
        this.loadColumnMetadata(this.activeTab);
        this.setAdvancedSearchFields();
        this.initVisibleColumns();

        // Reset lazy-load flags on tab change
        this.applicationDataLoaded = false;
        this.complaintDataLoaded = false;

        // Reset data grid page to 1
        if (this.dataGridComponent && this.dataGridComponent.dataGrid && this.dataGridComponent.dataGrid.instance) {
          this.dataGridComponent.dataGrid.instance.pageIndex(0);
        }

        if (tab === 'background') {
          // Background tab: prioritize Applications, defer Complaints
          this.Application = true;
          this.Complaint = false;
          this.fetchQueueData({ page: this.dataGridPage, pageSize: this.dataGridPageSize });
        } else {
          this.fetchQueueData({ page: this.dataGridPage, pageSize: this.dataGridPageSize });
        }
      }
      lastTab = tab;
    });
    const userObj = this.commonService.getCurrentUserData();
    if (userObj?.firstname && userObj?.lastname) {
      this.currentUserFullName = `${userObj.firstname} ${userObj.lastname}`;
    }
    this.userRoleId = Number(userObj?.userroles[0].id || 0);
    if (this.userRoleId === ROLE_ID.Compliance_Investigator || this.userRoleId === ROLE_ID.Chief_Compliance_Investigator) {
      this.showComplaintAddButton = true;
      this.showComplaintAssign = true;
    } else if (this.userRoleId === ROLE_ID.NDE_Administrator) {
      this.showComplaintAssign = true;
      this.showComplaintAddButton = false;
    }
    else {
      this.showComplaintAddButton = false;
      this.showComplaintAssign = false;
    }
    this.getComplaintActivationId();
  }

  clickComplaint() {
    this.showAdvancedSearch = false;
    this.loadComplaintSupportData();
    this.Complaint = !this.Complaint;
    this.cdr.markForCheck();
    if (this.Complaint && !this.complaintDataLoaded) {
      this.complaintDataLoaded = true;
      if (this.applicationDataLoaded && this.queueData?.length > 0) {
        // Data already available — extract and build grid immediately
        this.extractComplaintData();
        this.updateComplaintDataGridConfig();
        this.cdr.markForCheck();
      } else {
        // Data not loaded yet — fetch will trigger extractComplaintData via loadQueueData callback
        this.fetchQueueData();
      }
    } else if (this.Complaint) {
      // Re-opening — always re-extract so complaint grid binds latest payload
      this.extractComplaintData();
      this.cdr.markForCheck();
    }
  }

  toggleApplicationAccordion() {
    this.Application = !this.Application;
    if (this.Application && !this.applicationDataLoaded) {
      this.fetchQueueData();
    } else if (this.Application) {
      this.updateDataGridConfig(true);
      setTimeout(() => {
        this.updateDataGridConfig();
        this.cdr.detectChanges();
      }, 0);
    }
    this.cdr.markForCheck();
  }

  /** Extract complaint data from already-loaded queue data (background tab) */
  private extractComplaintData(): void {
    const queueComplaintContainer = Array.isArray(this.queueData)
      ? this.queueData.find((row: any) => Array.isArray(row?.complaint_list) && row.complaint_list.length > 0)
      : null;
    const applicationComplaintContainer = Array.isArray(this.applicationData)
      ? this.applicationData.find((row: any) => Array.isArray(row?.complaint_list) && row.complaint_list.length > 0)
      : null;

    const complaintSource =
      queueComplaintContainer?.complaint_list ||
      applicationComplaintContainer?.complaint_list ||
      [];

    this.complaintData = this.commonService.nullValueHandler(complaintSource);

    if (this.userRoleId === ROLE_ID.Compliance_Investigator) {
      this.complaintData = this.complaintData.filter((complaint: any) => complaint.complaint_status !== 'Submitted');
    }

    this.updateComplaintDataGridConfig();
  }

  onLicenseTypeSearch(searchValue: string) {
    this.licenseTypeSearchValue = searchValue;
    if (!searchValue) {
      this.filteredLicenseTypes = this.LICENSE_TYPES;
      return;
    }
    const lowerSearch = searchValue.toLowerCase();
    this.filteredLicenseTypes = this.LICENSE_TYPES.filter(type =>
      (type.key && type.key.toLowerCase().includes(lowerSearch)) ||
      (type.value && type.value.toLowerCase().includes(lowerSearch))
    );
  }

  private updateDataGridConfig(skipInitialFilters = false): void {
    this.dataGridConfig = new DataGridVO({
      role: this.activeTab,
      activeTab: this.activeTab,
      customHeaders: this.queuesHeaders,
      data: this.queueData,
      visibleColumns: this.visibleColumns,
      showQueueActions: true,
      customPageSize: 10,
      showNewDocumentIcon: (this.activeTab === 'doesNotQualify' || this.activeTab === 'deficiency'),
      showNewUploadIcon: (this.activeTab === 'doesNotQualify' || this.activeTab === 'deficiency' || this.activeTab === 'intake'),
      showStaffUpdateIcon: true,
      showPaymentCompletedIcon: true,
      // showNewApplicantUpdateIcon: true,
      disableApplicationClick: this.showColumnChooser,
      initialFilters: skipInitialFilters ? undefined : (this.activeTab === 'background' ? [['background_check_status', '=', this.backgroundCheckList], ['archive', '=', ['Active']]] : undefined),
    });
  }
  private updateComplaintDataGridConfig(): void {
    this.complaintGridData = new DataGridVO({
      customHeaders: this.complaintHeaders,
      data: this.complaintData,
      customPageSize: 10,
      visibleColumns: this.visibleComplaintColumns,
      showQueueActions: true,
      role: this.activeTab,
      activeTab: this.activeTab,
            plainTextEducatorName: true,
      initialFilters: [['complaint_archival_status', '=', ['Active']]],
    });
  }

  private initVisibleColumns() {
    if (!this.visibleColumns) {
      this.visibleColumns = {};
    }
    this.allColumns.forEach(c => {
      const key = (c.key || '').toString();
      if (key.toLowerCase() === 'archival_date' || key.toLowerCase() === 'archive') {
        this.visibleColumns[c.key] = (this.activeTab !== 'background');
      } else if (typeof this.visibleColumns[c.key] === 'undefined') {
        this.visibleColumns[c.key] = true;
      }
    });
    this.updateDataGridConfig();
  }


  selectTab(tabKey: string) {
    this.activeTab = tabKey;
    this.showAdvancedSearch = false;
    this.activeSearchFieldCount = 0;
    this.setAdvancedSearchFields();
    this.loadColumnMetadata(tabKey);
    this.loadQueueData(tabKey);
    this.updateDataGridConfig();
    this.lastAdvancedSearchValues = null;
    if (this.searchForms && this.searchForms.first) {
      this.searchForms.first.reset();
    }
     sessionStorage.removeItem('userapplicationmode');
  }

  onTabSelected(tabKey: string) {
    // Prevent re-clicking the same tab
    if (this.activeTab === tabKey) {
      return;
    }
     sessionStorage.removeItem('userapplicationmode');
    this.router.navigate(['/pages/queues/', tabKey]);
    this.selectTab(tabKey);
  }

  loadColumnMetadata(role: string) {
    if (!role) return;
    this.commonService
      .getQueuesData(role)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          this.queuesHeaders = headers;
          if (Array.isArray(headers)) {
            this.allColumns = headers.map((h: any) => {
              let isArchival = h.dataField === 'archival_date' || h.dataField === 'Archival_Date';
              return {
                key: h.dataField,
                label: h.caption || h.dataField,
                visible: isArchival ? false : (typeof h.visible !== 'undefined' ? h.visible : true),
                disabled: h.dataField === 'application_id'
              };
            });
          }
          this.initVisibleColumns();
        }
      });
    this.updateDataGridConfig()
  }

  fetchQueueData(searchPayload: any = {}) {
    this.fetchQueueDataTrigger$.next(searchPayload);
  }

  private _fetchQueueData(searchPayload: any = {}) {
    if (this.fetchQueueDataSubscription) {
      this.fetchQueueDataSubscription.unsubscribe();
    }
    const payload = {
      // ...this.buildQueueStatusPayload(this.activeTab),
      tab: searchPayload?.tab ?? this.activeTab,
      // page: searchPayload?.page ?? 1,
      // pageSize: searchPayload?.pageSize ?? 10,
      ...searchPayload
    };
    this.fetchQueueDataSubscription = this.queuesService.getRegistrationTabQueues(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (resp: any) => {
          let result = resp?.data?.data || resp?.data || resp;
          const total = resp?.data?.totalCount ?? resp?.data?.total ?? resp?.data?.totalRecords ?? resp?.data?.total_records ?? resp?.total ?? result?.total ?? (Array.isArray(result) ? result.length : 0);
          const pageSize = resp?.data?.pageSize ?? resp?.data?.page_size ?? searchPayload?.pageSize ?? this.dataGridPageSize;

          // Helper function to decrypt a field safely
          const decryptField = (value: any): any => {
            try {
              return this.commonService.decrypt(value);
            } catch {
              return value; // Return original if decrypt fails
            }
          };

          const formatEducatorName = (item: any): string => this.formatEducatorName(item);

          if (Array.isArray(result)) {
            // Only decrypt when advanced search is active (performance optimization)
            if (this.showAdvancedSearch === true) {
              this.applicationData = result.map((item) => ({
                ...item,
                educator_name: formatEducatorName(item),
                licenseNumber: decryptField(item.licenseNumber),
                licenseType: decryptField(item.licenseType),
                prior_name: decryptField(item.prior_name),
                ssn_number: decryptField(item.ssn_number),
                license_number: decryptField(item.license_number),
                cd_license_type: decryptField(item.cd_license_type),
                date_of_birth: decryptField(item.date_of_birth),
                institution_name: decryptField(item.institution_name),
                primary_email: decryptField(item.primary_email),
                recovery_email: decryptField(item.recovery_email),
                primary_phone: decryptField(item.primary_phone),
                itin_number: decryptField(item.itin_number),
                updated_date: decryptField(item.updated_date),
                EPP_Identifier: decryptField(item.EPP_Identifier),
                has_suspended_or_revoked_license: decryptField(item.has_suspended_or_revoked_license),
                has_cert_or_license_revoked: decryptField(item.has_cert_or_license_revoked),
                has_disciplinary_action: decryptField(item.has_disciplinary_action),
                has_criminal_conviction: decryptField(item.has_criminal_conviction),
                has_sexual_offense_arrest: decryptField(item.has_sexual_offense_arrest),
                has_child_abuse_substantiated: decryptField(item.has_child_abuse_substantiated),
                is_not_subject_child_support: decryptField(item.is_not_subject_child_support),
                is_subject_child_support_compliant: decryptField(item.is_subject_child_support_compliant),
                is_subject_child_support_noncompliant: decryptField(item.is_subject_child_support_noncompliant),
                fingerprint_date: item.re_fingerprint_date ? item.re_fingerprint_date : item.fingerprint_date
              }));
            } else {
              // Skip expensive decryption when advanced search is not active for better performance
              this.applicationData = result.map((item) => ({
                ...item,
                educator_name: formatEducatorName(item)
              }));
            }
          } else if (result && typeof result === 'object') {
            this.applicationData = [{ ...result, educator_name: formatEducatorName(result) }];
          } else {
            this.applicationData = [];
          }
          this.queueTabPageData = {
            data: this.applicationData,
            total,
            pageSize
          };
          // Render grid immediately, then fetch unread counts in background (fire-and-forget)
          this.loadQueueData(this.activeTab);

          // this.checkAndNotifyOverdueApplications();
          // Defer unread message fetching to avoid blocking the first grid paint.
          if (this.activeTab !== 'background') {
            setTimeout(() => this.loadUnreadMessageCountAndMap(this.applicationData), 0);
          } else {
            this.runWhenBrowserIdle(() => this.loadUnreadMessageCountAndMap(this.applicationData), 1500);
          }
        },
        error: (_err: any) => {
          this.queueData = [];
          this.updateDataGridConfig();
          this.alertService.error(errorMessages.fetchQueueData);
        }
      });
  }

  onQueuePageChange(event: { page: number; pageSize: number }) {
    this.dataGridPage = event.page;
    this.dataGridPageSize = event.pageSize;
    this.fetchQueueData({ page: event.page, pageSize: event.pageSize });
  }
  onFilterChange(event: { column: any; value: any }) {

  }
  onUnArchival() {
    this.fetchQueueData();
  }
  onAdvancedSearchReset(formRef?: DynamicSearchFormComponent) {
    sessionStorage.removeItem('userapplicationmode');
    if (formRef && typeof formRef.reset === 'function') {
      formRef.reset();
      setTimeout(() => {
        if (this.advancedSearchFields && formRef.form) {
          this.advancedSearchFields.forEach(field => {
            if (field.datatype === 'dropdown') {
              formRef.form.get(field.fieldName)?.setValue(null);
            }
          });
        }
        // Now call fetchQueueData after reset is complete
        this.fetchQueueData();
      }, 0);
      this.lastAdvancedSearchValues = null;
      this.activeSearchFieldCount = 0;
      this.updateDataGridConfig();
    }
  }

  loadQueueData(queueName: string) {
    if (Array.isArray(this.applicationData)) {
      const filterDirective = new QueueStatusFilterDirective();
      filterDirective.queueName = queueName;
      filterDirective.data = this.applicationData;
      this.queueData = filterDirective.filteredData;
      this.originalQueueData = [...this.applicationData];
    } else {
      this.queueData = [];
      this.originalQueueData = [];
    }

    if (queueName === 'background') {
      // Mark Applications section as loaded and render immediately
      this.applicationDataLoaded = true;
      this.updateDataGridConfig();
      this.scheduleBackgroundDeferredLoad();

      // Defer complaint data extraction to background if accordion is already open
      if (this.Complaint && this.complaintDataLoaded) {
        this.runWhenBrowserIdle(() => {
          this.extractComplaintData();
          this.cdr.markForCheck();
        }, 250);
      }
    } else {
      this.updateDataGridConfig();
    }
  }

  closeColumnChooser() {
    this.showColumnChooser = false;
    this.updateDataGridConfig();
  }
  closeComplaintColumnChooser() {
    this.showComplaintColumnChooser = false;
    this.updateComplaintDataGridConfig();
  }

  downloadExcel() {
    const columns = this.allColumns.filter(col => this.visibleColumns[col.key]);

    if (columns.length === 0) {
      this.alertService.warn('No columns selected for export');
      return;
    }

    if (this.dataGridComponent && this.dataGridComponent.exportFilteredDataToExcel) {
      const sheetName = `${QUEUE_CONSTANTS.FILE_DOWNLOAD_PREFIX}${this.activeTab || QUEUE_CONSTANTS.FILE_FALLBACK_NAME}.xlsx`;
      this.dataGridComponent.exportFilteredDataToExcel(columns, sheetName);
    } else {
      const rows = Array.isArray(this.queueData) ? this.queueData : [];
      if (rows.length === 0) {
        this.alertService.warn('No data to export');
        return;
      }
      const sheetName = `${QUEUE_CONSTANTS.FILE_DOWNLOAD_PREFIX}${this.activeTab || QUEUE_CONSTANTS.FILE_FALLBACK_NAME}.xlsx`;
      this.commonService.exportToExcel(rows, columns, sheetName);
    }
  }


  setColumnVisible(key: string, visible: boolean) {
    if (!this.visibleColumns) this.visibleColumns = {};
    if (key === 'application_id') {
      return;
    }
    this.visibleColumns[key] = !!visible;
    // Refresh advanced search fields when archival_date column is toggled in background tab
    if (key === 'archival_date' && this.activeTab === 'background') {
      this.setAdvancedSearchFields();
    }
    this.updateDataGridConfig();
  }

  onColumnToggle(key: string): void {
    const current = !!this.visibleColumns[key];
    this.setColumnVisible(key, !current);
  }

  onColumnClick(col: { key: string; label: string;[k: string]: any }): void {
    col.flagged = true;
    this.onColumnToggle(col.key);
  }
  onComplaintColumnClick(key: string): void {
    const current = !!this.visibleComplaintColumns[key];
    if (!this.visibleComplaintColumns) this.visibleComplaintColumns = {};
    this.visibleComplaintColumns[key] = !current;
    this.updateComplaintDataGridConfig();
  }
  onColumnKey(event: KeyboardEvent, col: { key: string; label: string;[k: string]: any }): void {
    const k = event && (event as KeyboardEvent).key;
    if (k === 'Enter' || k === ' ') {
      event.preventDefault();
      col.flagged = true;
      this.onColumnToggle(col.key);
    }
  }
  onEducatorNameClick = (_name: string, event?: Event, rowData?: any): void => {
    if (event && typeof (event as any).preventDefault === 'function') {
      (event as Event).preventDefault();
    }
    const applicationId = rowData?.id;
    if (applicationId == null || applicationId === '') {
      this.alertService.error('Application record has no application id; cannot fetch person details.', true);
      return;
    }
    // Call API to get person ID from application ID
    this.queuesService.getPersonIdByApplicationId(applicationId)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
         const personId = response?.data?.data?.personId;
          if (personId == null || personId === '') {
            this.alertService.error('Could not fetch person id for this application.', true);
            return;
          }
          this.sessionStorage.setItem(LOOKUP_USER_RETURN_URL_KEY, `/pages/queues/${this.activeTab}`);
          this.router.navigate(['/pages/lookup-user', String(personId)]);
        },
        error: (err) => {
          console.error('Error fetching person ID:', err);
          this.alertService.error('Failed to fetch person details. Please try again.', true);
        }
      });
  };

  onApplicationIdClick = (event: any, domEvent?: Event): void => {
    if (domEvent && typeof domEvent.preventDefault === 'function') {
      domEvent.preventDefault();
    }
    // sessionStorage.removeItem('userapplicationmode');
    let selectedApp = null;
    const roleId = this.sessionStorage.getItem('user') ? JSON.parse(this.sessionStorage.getItem('user') || '{}') : null;
    if (roleId && roleId.firstname && roleId.lastname) {
      this.currentUserFullName = `${roleId.firstname} ${roleId.lastname}`;
    }
    if (Array.isArray(this.applicationData)) {
      selectedApp = this.applicationData.find(app => String(app.id).trim() === String(event).trim());
    } else if (this.applicationData && String(this.applicationData.id) === String(event)) {
      selectedApp = this.applicationData;
    }


    if ((selectedApp && selectedApp.application_status === "Analyst Approved + BG Approved")) {
        window.sessionStorage.setItem('userapplicationmode', JSON.stringify('viewmode'));
    } else {
        window.sessionStorage.removeItem('userapplicationmode');
    }
    if (selectedApp && selectedApp.lockstatus === LOCK_STATUS[3].LONG_NM &&
      selectedApp.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')
    ) {
      const options: NgbModalOptions = {
        backdrop: 'static',
        centered: true,
        size: 'md'
      };
      this.customModal = this.ngbService.open(ModalComponent, options);
      const modalConfig: ModalConfig = {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.viewApplication, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.viewLockedAp,
        modalContent: modalContent.viewLockedApp(selectedApp.locked_by),
        hasTemplate: true
      };
      this.customModal.componentInstance.modalConfig = modalConfig;
      this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
        if (response && response.confirmed === true) {
          this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
          this.sessionStorage.setItem('surrenderMode','view');
          this.viewApplication(selectedApp);
        }
      });
      return;
    }
    if (
      selectedApp &&
      selectedApp.lockstatus === LOCK_STATUS[0].CD &&
      selectedApp.locked_by &&
      selectedApp.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')
    ) {
      const lockedByTrimmed = selectedApp.locked_by.trim();
      const options: NgbModalOptions = {
        backdrop: 'static',
        centered: true,
        size: 'md'
      };
      this.customModal = this.ngbService.open(ModalComponent, options);
      const modalConfig: ModalConfig = {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.viewApplication, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.AssignApplication,
        modalContent: modalContent.tempLockApp(lockedByTrimmed),
        hasTemplate: true
      };
      this.customModal.componentInstance.modalConfig = modalConfig;
      this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
        if (response && response.confirmed === true) {
          this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
          this.sessionStorage.setItem('surrenderMode','view');
          this.viewApplication(selectedApp);
        }
      });
      return;
    }
    if (
      selectedApp &&
      selectedApp.lockstatus &&
      selectedApp.lockstatus !== LOCK_STATUS_CODES.UNLOCKED && selectedApp.lockstatus !== '---' &&
      selectedApp.locked_by &&
      selectedApp.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')
    ) {
      this.viewApplication(selectedApp);
      return;
    }
    if (selectedApp && (!selectedApp.lockstatus || selectedApp.lockstatus === '---' || selectedApp.lockstatus === LOCK_STATUS_CODES.UNLOCKED)) {
      this.tempLockQueue(selectedApp);
    }


    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
    if (selectedApp) {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      this.sessionStorage.setItem('applicationmode', JSON.stringify('edit'));
      this.sessionStorage.setItem('surrenderMode','edit');

       if(this.activeTab == queues[5]){
        this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
      }
      // making extension application as ReadOnly
      if (selectedApp?.application_type === "License Extension") {
        this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
      }
      const userId = user?.id || user?.user_id || user?.userId;

      if (!userId) {
        console.error(errorMessages.noValidUser);
        return;
      }
      this.viewApplication(selectedApp);
    } else {
      console.error('Application not found:', event);
    }
  };
  viewApplication(selectedApp: any) {
    if (this.dataGridComponent) {
      this.dataGridComponent.viewApplication(selectedApp);
    }
  }
  tempLockQueue(_rowData: any) {
    if (this.dataGridComponent) {
      this.dataGridComponent.tempLockQueue(_rowData);
    }
  }
  onAssignSuccess() {

    this.fetchQueueData();
    // this.selectTab(this.activeTab);
  }

  onAssign(record: any, assign: boolean, selectedStaffMemberId?: any, personsByRole?: any) {
    if (!record || !record.application_id) {
      return;
    }
    let userId: string | null = null;
    const userObj = this.commonService.getCurrentUserData();
    if (userObj) {
      userId = userObj?.id || userObj?.user_id || userObj?.userId || null;
    }

    if (!userId) {
      return;
    }

    const assignToUserId = selectedStaffMemberId || userId;
    let assignedToFullName = '';
    const roleId = this.sessionStorage.getItem('user') ? JSON.parse(this.sessionStorage.getItem('user') || '{}') : null;
    if (selectedStaffMemberId && personsByRole) {
      const selectedPerson = personsByRole.find(
        person => (person.id || person.user_id || person.userId || person.person_id) === selectedStaffMemberId
      );
      if (selectedPerson) {
        assignedToFullName = selectedPerson.full_name;
      }
    }

    const payload = {
      applicationNumber: record.id,
      userId: assign ? assignToUserId : null,
      lockStatus: assign ? LOCK_STATUS_CODES.LOCKED : LOCK_STATUS_CODES.UNLOCKED
    };
    this.queuesService
      .updateLockStatus(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (_response: any) => {
          if (assign === true) {
            record.locked_by_user_id = this.currentUserFullName;
            record.locked_by = assignedToFullName || this.currentUserFullName;
            record.lockstatus = LOCK_STATUS_CODES.LOCKED;
            this.notifyApplicationAssignment(record.id, assignToUserId, this.currentUserFullName);
          } else {
            record.lockstatus = LOCK_STATUS_CODES.UNLOCKED;
            record.locked_by_user_id = null;
          }
          this.onAssignSuccess();
        },
        error: _error => {
          if (assign === true) {
            this.alertService.error(errorMessages.assignMsg);
          } else {
            this.alertService.error(errorMessages.unassignMsg);
          }
        }
      });
  }
  get advancedSearchRows() {
    const rows = [];
    for (let i = 0; i < this.advancedSearchFields.length; i += 4) {
      rows.push(this.advancedSearchFields.slice(i, i + 4));
    }
    return rows;
  }



  private normalizeString(str: string): string {
    if (!str) return '';
    return str.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private hasWildcard(value: any): boolean {
    return typeof value === 'string' && value.includes('*');
  }


  private isValidSSNITIN(digits: string): boolean {
    if (!digits || digits.length !== 9) return false;
    if (this.isAllZeros(digits)) return false;
    if (this.isRepeatedDigits(digits)) return false;
    if (digits.charAt(0) === '9') {
      return this.isValidITINRange(digits);
    }
    return this.isValidSSNRange(digits);
  }

  private isAllZeros(digits: string): boolean {
    return digits.substring(0, 3) === '000' ||
      digits.substring(3, 5) === '00' ||
      digits.substring(5, 9) === '0000';
  }

  private isRepeatedDigits(digits: string): boolean {
    return /^(\d)\1{8}$/.test(digits);
  }

  private isValidITINRange(digits: string): boolean {
    const middleDigits = parseInt(digits.substring(3, 5), 10);
    return (
      (middleDigits >= 50 && middleDigits <= 65) ||
      (middleDigits >= 70 && middleDigits <= 88) ||
      (middleDigits >= 90 && middleDigits <= 92) ||
      (middleDigits >= 94 && middleDigits <= 99)
    );
  }

  private isValidSSNRange(digits: string): boolean {
    const firstThreeDigits = parseInt(digits.substring(0, 3), 10);
    if (firstThreeDigits >= 900 && firstThreeDigits <= 999) return false;
    if (digits.substring(0, 3) === '666') return false;
    const lastThree = parseInt(digits.substring(6), 10);
    if (digits.substring(0, 6) === '987654' && lastThree >= 320 && lastThree <= 329) return false;
    if (digits === '078051120') return false;
    return true;
  }


  private matchSSNITIN(item: any, searchValue: string): boolean {
    const ssnRaw = (item['ssn_number'] || '').toString().replace(/\D/g, '');
    const itinRaw = (item['itin_number'] || '').toString().replace(/\D/g, '');

    if (this.hasWildcard(searchValue)) {
      return this.matchWildcardSSNITIN([ssnRaw, itinRaw], searchValue);
    }

    const rawValue = searchValue.replace(/\D/g, '');
    if (rawValue.length < 3) return false;

    if (rawValue.length === 9) {
      if (!this.isValidSSNITIN(rawValue)) return false;
      return ssnRaw === rawValue || itinRaw === rawValue;
    }

    return ssnRaw.includes(rawValue) || itinRaw.includes(rawValue);
  }

  private matchWildcardSSNITIN(targets: string[], searchValue: string): boolean {
    const searchRaw = searchValue.replace(/[^\d*]/g, '');
    const segments = searchRaw.split('*').filter(s => s.length > 0);

    if (segments.length === 0) {
      return targets.some(target => target.length > 0);
    }

    return targets.some(target => {
      if (!target) return false;
      let startPos = 0;
      for (const segment of segments) {
        const pos = target.indexOf(segment, startPos);
        if (pos === -1) return false;
        startPos = pos + segment.length;
      }
      return true;
    });
  }


  private matchTextField(itemValue: string, searchValue: string, _fieldKey: string): boolean {
    if (!itemValue || itemValue.trim() === '') return false;
    if (!searchValue || searchValue.trim() === '') return false;

    const normalizedItem = this.normalizeString(itemValue);
    const normalizedSearch = this.normalizeString(searchValue);

    if (normalizedSearch.includes('*')) {
      const parts = normalizedSearch.split('*').filter(p => p.length > 0);
      if (parts.length === 0) {
        return true;
      }
      let searchPos = 0;
      for (const part of parts) {
        const idx = normalizedItem.toLowerCase().indexOf(part.toLowerCase(), searchPos);
        if (idx === -1) return false;
        searchPos = idx + part.length;
      }
      return true;
    }

    return normalizedItem.toLowerCase().includes(normalizedSearch.toLowerCase());
  }


  private matchDateField(itemValue: any, searchValue: string): boolean {
    if (!itemValue || !searchValue) return false;

    if (itemValue === '---') return false;

    const itemDate = new Date(itemValue);
    if (isNaN(itemDate.getTime())) return false;

    const trimmedSearch = searchValue.trim();
    const mm = String(itemDate.getMonth() + 1).padStart(2, '0');
    const dd = String(itemDate.getDate()).padStart(2, '0');
    const yyyy = itemDate.getFullYear();
    const formattedItemDate = `${mm}/${dd}/${yyyy}`;

    if (this.isWildcardSearch(trimmedSearch, formattedItemDate)) {
      return true;
    }

    if (this.isMonthDayMatch(trimmedSearch, itemDate)) {
      return true;
    }

    if (this.isYearOnlyMatch(trimmedSearch, itemDate)) {
      return true;
    }

    if (this.isMonthYearMatch(trimmedSearch, itemDate)) {
      return true;
    }

    if (this.isFullDateShortYearMatch(trimmedSearch, itemDate)) {
      return true;
    }

    if (this.isFullDateMatch(trimmedSearch, itemDate)) {
      return true;
    }
    return formattedItemDate.includes(trimmedSearch);
  }

  private isWildcardSearch(trimmedSearch: string, formattedItemDate: string): boolean {
    if (!trimmedSearch.includes('*')) return false;
    const parts = trimmedSearch.split('*').filter(p => p.length > 0);

    if (parts.length === 0) {
      return true;
    }
    let searchPos = 0;
    for (const part of parts) {
      const idx = formattedItemDate.indexOf(part, searchPos);
      if (idx === -1) return false;
      searchPos = idx + part.length;
    }
    return true;
  }

  private isMonthDayMatch(trimmedSearch: string, itemDate: Date): boolean {
    if (/^\d{1,2}\/\d{1,2}$/.test(trimmedSearch)) {
      const [month, day] = trimmedSearch.split('/');
      return itemDate.getMonth() + 1 === parseInt(month, 10) && itemDate.getDate() === parseInt(day, 10);
    }
    return false;
  }

  private isYearOnlyMatch(trimmedSearch: string, itemDate: Date): boolean {
    if (/^\d{4}$/.test(trimmedSearch)) {
      return itemDate.getFullYear() === parseInt(trimmedSearch, 10);
    }
    return false;
  }

  private isMonthYearMatch(trimmedSearch: string, itemDate: Date): boolean {
    if (/^\d{1,2}\/\d{4}$/.test(trimmedSearch)) {
      const [month, year] = trimmedSearch.split('/');
      return itemDate.getMonth() + 1 === parseInt(month, 10) && itemDate.getFullYear() === parseInt(year, 10);
    }
    return false;
  }

  private isFullDateShortYearMatch(trimmedSearch: string, itemDate: Date): boolean {
    if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(trimmedSearch)) {
      const [month, day, shortYear] = trimmedSearch.split('/');
      const fullYear = parseInt(shortYear, 10) + (parseInt(shortYear, 10) < 50 ? 2000 : 1900);
      return (
        itemDate.getMonth() + 1 === parseInt(month, 10) &&
        itemDate.getDate() === parseInt(day, 10) &&
        itemDate.getFullYear() === fullYear
      );
    }
    return false;
  }

  private isFullDateMatch(trimmedSearch: string, itemDate: Date): boolean {
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(trimmedSearch)) {
      const [month, day, year] = trimmedSearch.split('/');
      return (
        itemDate.getMonth() + 1 === parseInt(month, 10) &&
        itemDate.getDate() === parseInt(day, 10) &&
        itemDate.getFullYear() === parseInt(year, 10)
      );
    }
    return false;
  }

  private doesItemMatch(item: any, values: any): boolean {
    for (const [searchKey, value] of Object.entries(values)) {
      if (this.shouldSkipValue(value)) continue;

      const fieldConfig = this.advancedSearchFields.find(f => f.key === searchKey || f.fieldName === searchKey);

      if (this.isDateRangeField(fieldConfig, value)) {
        if (!this.handleDateRangeField(item, searchKey, value)) return false;
        continue;
      }

      if (Array.isArray(value)) {
        if (!this.handleDateRangeField(item, searchKey, value)) return false;
        continue;
      }

      const key = searchKey;
      const searchValue = typeof value === 'string' ? value.trim() : value;
      if (searchValue === '') continue;
      const itemValue = item[key];

      if (!this.matchField(key, fieldConfig, item, itemValue, searchValue)) return false;
    }
    return true;
  }

  private shouldSkipValue(value: any): boolean {
    return value === undefined || value === null || value === '';
  }

  private isDateRangeField(fieldConfig: any, value: any): boolean {
    return fieldConfig?.datatype === 'daterange' && Array.isArray(value);
  }

  private handleDateRangeField(item: any, searchKey: string, value: any): boolean {
    const [startDate, endDate] = value as [Date | null, Date | null];
    if (!startDate && !endDate) return true;
    const rangeItemValue = item[searchKey];
    return this.matchDateRangeField(rangeItemValue, startDate, endDate);
  }

  private matchField(
    key: string,
    fieldConfig: any,
    item: any,
    itemValue: any,
    searchValue: any
  ): boolean {
    if (key === 'ssn_number') {
      return this.matchSSNITIN(item, searchValue);
    }
    if (fieldConfig?.datatype === 'date') {
      return this.matchDateField(itemValue, searchValue);
    }
    // Custom match for license_type dropdown
    if (key === 'license_type' && fieldConfig?.datatype === 'dropdown') {
      // Match by key or value
      const search = (searchValue || '').toLowerCase();
      if (!search) return true;
      const type = this.LICENSE_TYPES.find(t =>
        (t.key && t.key.toLowerCase() === search) ||
        (t.value && t.value.toLowerCase() === search)
      );
      if (!type) return false;
      return (
        (itemValue && itemValue.toLowerCase() === type.key.toLowerCase()) ||
        (itemValue && itemValue.toLowerCase() === type.value.toLowerCase())
      );
    }
    if (fieldConfig?.datatype === 'dropdown') {
      return itemValue == searchValue;
    }
    if (fieldConfig?.datatype === 'text' || typeof searchValue === 'string') {
      const itemStr = itemValue != null ? String(itemValue) : '';
      return this.matchTextField(itemStr, searchValue, key);
    }
    return itemValue == searchValue;
  }

  private matchDateRangeField(itemValue: any, startDate: Date | null, endDate: Date | null): boolean {
    if (itemValue === undefined) return true;
    if (!itemValue) return false;
    if (itemValue === '---') return false;

    let itemDate: Date;
    if (itemValue instanceof Date) {
      itemDate = new Date(itemValue);
    } else if (typeof itemValue === 'string') {
      if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(itemValue.trim())) {
        const [month, day, year] = itemValue.trim().split('/').map(Number);
        itemDate = new Date(year, month - 1, day);
      } else {
        itemDate = new Date(itemValue);
      }
    } else {
      itemDate = new Date(itemValue);
    }

    if (isNaN(itemDate.getTime())) return false;
    itemDate.setHours(0, 0, 0, 0);

    if (startDate) {
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      if (itemDate < start) return false;
    }

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);
      if (itemDate > end) return false;
    }

    return true;
  }

  private parseSearchDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    const trimmed = dateStr.trim();

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(trimmed)) {
      const [month, day, year] = trimmed.split('/').map(Number);
      const parsedDate = new Date(year, month - 1, day);
      parsedDate.setHours(0, 0, 0, 0);
      return parsedDate;
    }

    const standardDate = new Date(trimmed);
    if (!isNaN(standardDate.getTime())) {
      standardDate.setHours(0, 0, 0, 0);
      return standardDate;
    }

    return null;
  }

  onAdvancedSearch(values: any) {
    const searchPayload = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => {
          const dateFields = [
            'date_of_birth', 'updated_date', 'new_document_uploaded', 'fingerprint_date', 'archival_date',
            'dtEffStartDate', 'dtEffEndDate', 'Effective_Start_Date', 'Effective_End_Date',
            'DateUpdated', 'Expiration_Date_Rule', 'date_submitted', 'due_date', 'archival_date',
            'Date_Submitted', 'Due_Date', 'Archival_Date', 'created_date', 'submission_date',
            'Date Created', 'Date Submitted', 'Date Updated', 'date_sent', 're_submitted_date', 'license_expiration_date', 'fingerprint_date'
          ];
          if (dateFields.includes(k) && v) {
            if (Array.isArray(v) && v.length === 2) {
              return [k, { from: formatDateToYMD(v[0]), to: formatDateToYMD(v[1]) }];
            } else {
              return [k, formatDateToYMD(v)];
            }
          }
          return [k, v];
        })
    );
    const payload = {
      ...searchPayload,
      tab: searchPayload?.tab ?? this.activeTab,
      // pagination: { page: 1, pageSize: 10 }
    };
    this.queuesService.getRegistrationTabQueues(payload).pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (resp: any) => {
          let result = resp?.data?.data || resp?.data || resp;
          const total = resp?.data?.totalCount ?? resp?.data?.total ?? resp?.data?.totalRecords ?? resp?.data?.total_records ?? resp?.total ?? result?.total ?? (Array.isArray(result) ? result.length : 0);
          const pageSize = resp?.data?.pageSize ?? resp?.data?.page_size ?? 10;
          this.queueTabPageData = {
            data: Array.isArray(result) ? result : [],
            total,
            pageSize
          };
          if (Array.isArray(result)) {
            this.applicationData = result.map((item: any) => ({
              ...item,
              educator_name: this.formatEducatorName(item)
            }));
          } else if (result && typeof result === 'object') {
            this.applicationData = [{ ...result, educator_name: this.formatEducatorName(result) }];
          } else {
            this.applicationData = [];
          }
          this.queueTabPageData = {
            ...this.queueTabPageData,
            data: this.applicationData
          };
          // Render grid immediately, then fetch unread counts in background (fire-and-forget)
          this.loadQueueData(this.activeTab);
          // Defer unread message fetching to avoid blocking the first grid paint.
          if (this.activeTab === 'background') {
            this.runWhenBrowserIdle(() => this.loadUnreadMessageCountAndMap(this.applicationData), 1500);
          } else {
            setTimeout(() => this.loadUnreadMessageCountAndMap(this.applicationData), 0);
          }
        },
        error: (_err: any) => {
          this.queueData = [];
          this.updateDataGridConfig();
          this.alertService.error('Failed to fetch queue data');
        }
      });
  }
  refreshGrid() {
    sessionStorage.removeItem('userapplicationmode');
    // Only call fetchQueueData once
    this.fetchQueueData();
    this.showAdvancedSearch = false;
    this.lastAdvancedSearchValues = null;
    this.activeSearchFieldCount = 0;
    if (this.searchForms && this.searchForms.first) {
      this.searchForms.first.reset();
    }
    this.updateDataGridConfig();
  }
  openAdvancedSearch() {
     sessionStorage.removeItem('userapplicationmode');
    this.showAdvancedSearch = !this.showAdvancedSearch;
    if (this.showAdvancedSearch) {
      this.setAdvancedSearchFields();
      if (this.lastAdvancedSearchValues) {
        setTimeout(() => {
          if (this.searchForms && this.searchForms.first) {
            this.searchForms.first.form.patchValue(this.lastAdvancedSearchValues);
          }
        }, 0);
      }
    }
  }
  onHeaderFilterPopupShowing() {
    this.isHeaderFilterOpen = true;
  }

  onHeaderFilterPopupHidden() {
    this.isHeaderFilterOpen = false;
  }
  getLicenseTypeDisplay(key: string): string {
    const found = this.LICENSE_TYPES.find(type => type.key === key);
    return found ? found.value : key;
  }
  getLicenseTypeKey(display: string): string | undefined {
    const found = this.LICENSE_TYPES.find(type => type.value === display);
    return found ? found.key : undefined;
  }
  onCaseIdClick(event: Event,details?:any,flow?:string): void {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    if(flow == 'view'){
      this.sessionStorage.setItem('casemode', JSON.stringify('view'));
    }else{
      this.sessionStorage.setItem('casemode', JSON.stringify('edit'));
    }
    const selectedApp = this.applicationData.find(app =>
      String(app.id).trim() === String(event).trim() ||
      String(app.application_id).trim() === String(event).trim()
    );
    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
    this.sessionStorage.setItem('backgroundCheckStatus', JSON.stringify(selectedApp?.background_check_status ?? null));
    this.httpService.post(API_ENDPOINTS.Is_Case_Archived, { case_number: selectedApp.case_id })
    .pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        const caseData = response.data.data[0];
        console.log(caseData);
        const isArchivedCase = String(caseData?.cd_decision_status) === '4' || String(caseData?.cd_decision_status) === '3' ;
        const isCaseDeniedArchived = String(caseData?.cd_decision_status) === '4';
        const disableAllsections = String(caseData?.cd_case_archived) ==='2'
        const caseStatus = caseData?.cd_decision_status;
        this.sessionStorage.setItem('deniedArchivedCase', JSON.stringify(isCaseDeniedArchived));
        this.sessionStorage.setItem('archivedCase', JSON.stringify(isArchivedCase));
        this.sessionStorage.setItem('disableAllsections', JSON.stringify(disableAllsections));
        this.sessionStorage.setItem('caseStatus', JSON.stringify(caseStatus));
        console.log(isArchivedCase, isCaseDeniedArchived)
      }
      });

    this.myAppService
      .getApplication(selectedApp.id)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: personResponse => {
          const personData = personResponse.data[0];
          this.sessionStorage.setItem('personData', JSON.stringify(personData));
          let educatorName = selectedApp.educator_name ? selectedApp.educator_name : '';
          let suffix = '';
          if (personData.cd_suffix && this.suffixList && Array.isArray(this.suffixList)) {
            const found = this.suffixList.find((s: any) => String(s.key) === String(personData.cd_suffix));
            if (found) {
              suffix = found.value || '';
              personData.suffixValue = found.value; // Store suffix in personData for later use
              this.sessionStorage.setObj('personData', personData); // Update session storage with suffix
            }
          }
          if (suffix && suffix !== 'None') {
            educatorName = `${educatorName} ${suffix} `;
          }
          const bannerEducatorName = `${personData.first_name || ''} ${personData.last_name || ''}`.trim();
          const bannerheader = {
            'Case ID': selectedApp.case_id,
            'Case Type': 'Background Check',
            'Educator Name': bannerEducatorName,
            // 'Fingerprint Status': selectedApp.fingerprint_status || '---',
            // 'Background Status': selectedApp.background_check_status || '---',
          };
          const inputFormatForAppData = { bannerheader };
          this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));

          this.myAppService
            .getAppData(`appId=${selectedApp.id}`)
            .pipe(take(1), takeUntil(this.destroy$))
            .subscribe({
              next: appResponse => {
                const appData = appResponse.data.data[0];
                const { caseversionid } = appData;

                // Set cd_license_type in session storage from API response
                const licenseTypeFromApi = appData.alm_cd_license_type;
                if (licenseTypeFromApi && licenseTypeFromApi !== '---') {
                  this.sessionStorage.setItem('cd_license_type', licenseTypeFromApi.toString());
                  console.log('[QUEUES] Stored cd_license_type in session from API:', licenseTypeFromApi);
                }

                // Set licenseIssueDate in session storage from API response
                const licenseIssueDateFromApi = appData.alm_license_issue_date;
                if (licenseIssueDateFromApi) {
                  const issueDate = new Date(licenseIssueDateFromApi);
                  if (!isNaN(issueDate.getTime())) {
                    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0');
                    const day = issueDate.getDate().toString().padStart(2, '0');
                    const year = issueDate.getFullYear();
                    this.sessionStorage.setItem('licenseIssueDate', `${month}/${day}/${year}`);
                    console.log('[QUEUES] Stored licenseIssueDate in session from API:', `${month}/${day}/${year}`);
                  }
                }

                if (caseversionid) {
                  const sessionData: AssignmentSessionData = {
                    youthID: selectedApp.id || event,
                    youthNumber: selectedApp.application_number ?? selectedApp.application_id ?? selectedApp.id,
                    applicationID: selectedApp.id,
                    isFirstSave: 'false',
                    applicationType: "",
                    currApplicationType: "",
                    backToHome: { name: '/pages/queues/background' },
                    backToGridPage: { name: '/queues/background' },
                    // backButtonText: 'Close',
                    //applicationTotalFee: feeConstants[0].Amount,
                    //applicationFee: feeConstants[0].Amount
                  };

                  Object.entries(sessionData).forEach(([key, value]) => {
                    this.sessionStorage.setItem(key, JSON.stringify(value));
                  });
                  this.sessionStorage.setItem('backButtonText', 'Close');
                  this.router.navigate([`/pages/dynamic-routing/tab/${caseversionid}`]);
                  this.appService.addValue('currentPage', 'Case');
                } else {
                  console.error(errorMessages.noActiveVersionId);
                }
              },
              error: error => {
                console.error('Error getting app data:', error);
              }
            });
        },
        error: error => {
          console.error('Error getting person data:', error);
        }
      });
  }

  onComplaintIdClick(complaintFlowType: string, complaintStatus: string, complaintRowData: any): void {
    const roleId = this.sessionStorage.getItem('user') ? JSON.parse(this.sessionStorage.getItem('user') || '{}') : null;
    if (roleId && roleId.firstname && roleId.lastname) {
      this.currentUserFullName = `${roleId.firstname} ${roleId.lastname}`;
    }
    this.sessionStorage.setItem('complaintFlowType', complaintFlowType);
    const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
    this.sessionStorage.setObj('backToHome', '/pages/queues/background');
    this.sessionStorage.setItem('backButtonText', 'Close');
    this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/queues/background' }));
    if (complaintFlowType == 'add') {
      const payload = {
        intCreatedBy: user.id,
        strComplaintSource: COMPLAINT_SOURCE.INTERNAL,
        dtCreatedDate: new Date().toISOString(),
        intCdComplaintStatus: 7
      }
      this.complaintFormService.insertComplaint(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          if (response && response.status === 'success') {
            this.sessionStorage.setItem('complaintId', JSON.stringify(response.data?.data?.complaint_id));
            this.sessionStorage.setItem('complaintFormId', response.data?.data?.complaint_form_id);
            this.sessionStorage.setItem('complaintStatus', response.data?.data?.cd_complaint_status_value);
            this.sessionStorage.setItem('caseType', JSON.stringify('Complaint'));
            this.sessionStorage.setItem('youthID', JSON.stringify(complaintFlowType || event));
            const bannerheader: any = {
              'Complaint ID': response.data?.data?.complaint_id,
              'Case Type': 'Complaint'
            };
            const inputFormatForAppData = { bannerheader };
            this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
            this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`]);
          }
        },
        error: (error) => {
          console.error('Error inserting complaint:', error);
        }
      });
    } else {
      this.sessionStorage.setItem('complaintId', JSON.stringify(complaintFlowType));
      this.sessionStorage.setItem('complaintStatus', JSON.stringify(complaintStatus));
      this.sessionStorage.setItem('caseType', JSON.stringify('Complaint'));
      this.sessionStorage.setItem('youthID', JSON.stringify(complaintFlowType || event));

      if (complaintRowData && (complaintRowData.lockstatus === LOCK_STATUS[0].CD || complaintRowData.lockstatus === LOCK_STATUS[2].CD)
        && complaintRowData.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')) {
        const options: NgbModalOptions = {
          backdrop: 'static',
          centered: true,
          size: 'md'
        };
        this.customModal = this.ngbService.open(ModalComponent, options);
        this.customModalConfig = {
          buttons: [
            { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
            { text: modalButtonTitles.viewCase, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
          ],
          heading: modalHeading.assignedComplaint,
          modalContent: modalContent.assignedComplaint(complaintRowData.locked_by),
          hasTemplate: true
        }
        this.customModal.componentInstance.modalConfig = this.customModalConfig;
        this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
          if (response && response.confirmed === true) {
            this.sessionStorage.setItem('complaintMode', 'view');
            const bannerheader: any = {
              'Complaint ID': complaintFlowType,
              'Case Type': 'Complaint'
            };
            const inputFormatForAppData = { bannerheader };
            this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
            this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`]);
          }
        });
      } else if (complaintRowData && (complaintRowData.lockstatus === LOCK_STATUS[3].CD)
        && complaintRowData.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')) {
        const options: NgbModalOptions = {
          backdrop: 'static',
          centered: true,
          size: 'md'
        };
        this.customModal = this.ngbService.open(ModalComponent, options);
        this.customModalConfig = {
          buttons: [
            { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
            { text: modalButtonTitles.viewCase, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
          ],
          heading: modalHeading.viewLockedComplaint,
          modalContent: modalContent.viewLockedComplaint(complaintRowData.locked_by),
          hasTemplate: true
        }
        this.customModal.componentInstance.modalConfig = this.customModalConfig;
        this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
          if (response && response.confirmed === true) {
            this.sessionStorage.setItem('complaintMode', 'view');
            const bannerheader: any = {
              'Complaint ID': complaintFlowType,
              'Case Type': 'Complaint'
            };
            const inputFormatForAppData = { bannerheader };
            this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
            this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`]);
          }
        });
      } else if ((complaintRowData.lockstatus === '---' || complaintRowData.lockstatus === LOCK_STATUS[1].CD)
        && complaintRowData.locked_by.replace(/\s+/g, '') !== this.currentUserFullName.replace(/\s+/g, '')) {
        const payload = {
          complaintId: complaintFlowType,
          intUpdatedBy: user.id,
          intAssignee: user.id,
          lockStatus: LOCK_STATUS_CODES.TEMP_LOCKED
        }
        this.complaintFormService.updateComplaintAssignee(payload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (response) => {
            if (response && response.status === 'success') {
              this.sessionStorage.setItem('complaintMode', 'write');
              const bannerheader: any = {
                'Complaint ID': complaintFlowType,
                'Case Type': 'Complaint'
              };
              const inputFormatForAppData = { bannerheader };
              this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
              this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`])
            }
          },
          error: (error) => {
            console.error('Error updating temp lock status:', error);
          }
        });
      }
      else {
        this.sessionStorage.setItem('complaintMode', 'write');
        const bannerheader: any = {
          'Complaint ID': complaintFlowType,
          'Case Type': 'Complaint'
        };
        const inputFormatForAppData = { bannerheader };
        this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
        this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`]);
      }
    }
  }
  getComplaintActivationId() {
    this.complaintFormService.getComplaintActivationId().pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.status === 'success') {
          this.sessionStorage.setItem('complaintActiveversionid', JSON.stringify(response.data?.data[0]?.activeversionid));
        }
      },
      error: (error) => {
        console.error('Error getting complaint activation id:', error);
      }
    });
  }
  onAssignComplaint(row: any) {
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md'
    };
    this.customModal = this.ngbService.open(ModalComponent, options);
    if (row.lockstatus === LOCK_STATUS[0].CD || row.lockstatus === LOCK_STATUS[2].CD) {
      this.customModalConfig = {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.unassign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.unassignComplaint,
        modalContent: modalContent.unAssignComplaint,
        hasTemplate: true
      }
    } else {
      if (this.userRoleId === ROLE_ID.Chief_Compliance_Investigator || this.userRoleId === ROLE_ID.NDE_Administrator) {
        const dropdownOptions = this.assignToList.map(person => ({
          label: person.full_name,
          value: person.id || person.value
        }));
        this.customModalConfig = {
          buttons: [
            { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
            { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
          ],
          heading: modalHeading.assignComplaint,
          modalContent: modalContent.assignComplaintToStaffMember(),
          hasTemplate: true,
          hasDropdown: true,
          dropdownLabel: 'Assign To',
          dropdownOptions: dropdownOptions,
          dynamicContent: true
        }
      } else {
        this.customModalConfig = {
          buttons: [
            { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
            { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
          ],
          heading: modalHeading.assignComplaint,
          modalContent: modalContent.assignComplaint,
          hasTemplate: true
        }
      }
    }
    this.customModal.componentInstance.modalConfig = this.customModalConfig;
    this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
      if (response.confirmed === true) {
        const locked = (row.lockstatus !== LOCK_STATUS[0].CD && row.lockstatus !== LOCK_STATUS[2].CD);
        if (locked && (this.userRoleId === ROLE_ID.Chief_Compliance_Investigator || this.userRoleId === ROLE_ID.NDE_Administrator)) {
          this.complaintAssign(true, row, response.selectedStaffMember);
        } else if (locked && (this.userRoleId === ROLE_ID.Compliance_Investigator)) {
          this.complaintAssign(true, row);
        } else {
          this.complaintAssign(false, row);
        }
      }
    });
  }
  complaintAssign(assign: boolean, row: any, selectedStaffMemberId?: any) {
    let user = JSON.parse(this.sessionStorage.getItem('user'));
    let assignToUserId = selectedStaffMemberId || user.id;
    const payload = {
      complaintId: row.complaint_form_id,
      intUpdatedBy: user.id,
      intAssignee: assign ? assignToUserId : null,
      lockStatus: assign ? LOCK_STATUS_CODES.LOCKED : LOCK_STATUS_CODES.UNLOCKED
    }
    this.complaintFormService.updateComplaintAssignee(payload).pipe(take(1)).subscribe({
      next: (response) => {
        if (response && response.status === 'success') {
          this.onAssignSuccess();
          if (selectedStaffMemberId) {
            this.notification(row.complaint_form_id, selectedStaffMemberId)
          }
        }
      },
      error: (error) => {
        console.error('Error updating complaint assignee:', error);
      }
    });
  }
  notification(complaintId: any, assignedId: any) {
    const notify = (userid: number, roleid: number) => {
      const payload = {
        priority: "High",
        message: `Complaint ${complaintId} has been assigned to you. It is now available in the Background queue for review.`,
        actionurl: "/pages/compliant-review",
        userid,
        roleid,
        customformid: 1,
        isnew: true,
        isactive: true
      };
      this.fingerprintService.FingerPrintPortalnotifiction(payload)
        .pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (res: any) => {
            if (!res.data.success) {
              console.error(`Error while sending notification for user ${userid}, role ${roleid}`);
            }
          },
          error: err => {
            console.error(`Error sending notification for user ${userid}, role ${roleid}:`, err);
          }
        });
    };
    notify(Number(assignedId), null);
  }

  viewNotes(row: any, tabNameOverride?: string) {
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'xl',
      windowClass: 'internal-notes-modal-window'
    };
    const modalRef = this.ngbService.open(InternalNotesModalComponent, options);
    const applicationId = row?.application_id ?? row?.complaint_form_id ?? row?.id ?? '';
    const idForName = row?.complaint_form_id || applicationId || row?.id || '';
    modalRef.componentInstance.title = 'Internal Notes';
    modalRef.componentInstance.exportFileName = idForName
      ? `Internal Notes - ${idForName}`
      : 'Internal Notes';

    // Pass the actual active tab name through as tabName.
    // (Previously admin/analyst/intake/deficiency/doesNotQualify were all mapped to
    // 'case management', which is incorrect — only send 'case management' when actually
    // on a case management tab.)
    const tabName: string = tabNameOverride
      ? String(tabNameOverride).trim()
      : (this.activeTab ? String(this.activeTab).trim() : '');

    if (tabName && applicationId) {
      const payload = { tabName, applicationId };
      // Section field source:
      //   background or case-management tabs -> response field `cd_section`
      //   any other tab                      -> response field `section_code`
      const caseManagementTabs = ['admin', 'analyst', 'intake', 'deficiency', 'doesNotQualify'];
      const useCdSection = tabName === 'background' || caseManagementTabs.includes(tabName);
      this.queuesService.getInternalNotes(payload).pipe(take(1)).subscribe({
        next: (response: any) => {
          const rawList = response?.data?.data || response?.data || [];
          // Debug: confirm what field names the backend actually returns.
          if (Array.isArray(rawList) && rawList.length) {
            console.log('[InternalNotes][queues] raw item keys:', Object.keys(rawList[0]), rawList[0]);
          }
          const pickSection = (item: any) => {
            const primary = useCdSection ? item?.cd_section : item?.section_code;
            const fallback = useCdSection ? item?.section_code : item?.cd_section;
            return primary ?? fallback ?? item?.section ?? item?.section_name ?? '';
          };
          const pickUpdatedDate = (item: any) =>
            item?.updated_date ?? item?.updated_at ?? item?.updated_on ?? item?.modified_date
            ?? item?.modified_at ?? item?.last_updated ?? item?.last_updated_date
            ?? item?.created_date ?? item?.created_at ?? '';
          const mapped = Array.isArray(rawList)
            ? rawList.map((item: any) => ({
                section: pickSection(item),
                notes: item?.note_text ?? item?.notes ?? '',
                added_by: (item?.created_by_name && String(item.created_by_name).trim())
                  || (item?.added_by && String(item.added_by).trim())
                  || (item?.created_by != null ? String(item.created_by) : ''),
                updated_date: pickUpdatedDate(item)
              }))
            : [];
          modalRef.componentInstance.notes = mapped;
        },
        error: () => {
          modalRef.componentInstance.notes = [];
        }
      });
    } else {
      modalRef.componentInstance.notes = Array.isArray(row?.internal_notes) ? row.internal_notes : [];
    }
  }

  viewComplaint(row: any) {
    this.sessionStorage.setItem('complaintFlowType', row.complaint_form_id);
    this.sessionStorage.setItem('complaintId', JSON.stringify(row.complaint_form_id));
    this.sessionStorage.setItem('complaintStatus', JSON.stringify(row.complaint_status));
    this.sessionStorage.setItem('caseType', JSON.stringify('Complaint'));
    this.sessionStorage.setItem('youthID', JSON.stringify(row.complaint_form_id || event));
    this.sessionStorage.setItem('complaintMode', 'view');
    this.sessionStorage.setObj('backToHome', '/pages/queues/background');
    this.sessionStorage.setItem('backButtonText', 'Close');
    this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/queues/background' }));
    const bannerheader: any = {
      'Complaint ID': row.complaint_form_id,
      'Case Type': 'Complaint'
    };
    const inputFormatForAppData = { bannerheader };
    this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
    this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('complaintActiveversionid')}`]);
  }
  downloadCompliant(row: any) {
    this.sessionStorage.setItem('complaintFlowType', row.complaint_form_id);
    this.sessionStorage.setItem('complaintId', JSON.stringify(row.complaint_form_id));
    this.sessionStorage.setItem('complaintStatus', JSON.stringify(row.complaint_status));
    this.sessionStorage.setItem('caseType', JSON.stringify('Complaint'));
    this.sessionStorage.setItem('youthID', JSON.stringify(row.complaint_form_id || event));
    this.sessionStorage.setItem('complaintMode', 'view');
    this.sessionStorage.setObj('backToHome', '/pages/queues/background');
    this.sessionStorage.setItem('backButtonText', 'Close');
    this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/queues/background' }));
    const bannerheader: any = {
      'Complaint ID': row.complaint_form_id,
      'Case Type': 'Complaint'
    };
    const inputFormatForAppData = { bannerheader };
    this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
    this.commonService.downloadComplaint(row.complaint_form_id);
  }

  ngOnDestroy(): void {
    if (this.fetchQueueDataSubscription) {
      this.fetchQueueDataSubscription.unsubscribe();
    }
    if (this.paramMapSubscription) {
      this.paramMapSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.fetchQueueDataTrigger$) {
      this.fetchQueueDataTrigger$.complete();
    }
  }
  onResetClick() {
    setTimeout(() => {
      if (this.advancedSearchFields && this.searchForms.first && this.searchForms.first.form) {
        this.advancedSearchFields.forEach(field => {
          if (field.datatype === 'dropdown') {
            this.searchForms.first.form.get(field.fieldName)?.setValue(null);
          }
        });
      }
      this.lastAdvancedSearchValues = null;
      this.activeSearchFieldCount = 0;
      this.updateDataGridConfig();
      this.fetchQueueData();
    }, 0);
  }

  private getCurrentUserIdForMessages(): number | null {
    try {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      const id = user?.id ?? user?.userId ?? user?.user_id ?? this.sessionStorage.getItem('id');
      if (id == null) return null;
      const num = typeof id === 'number' ? id : parseInt(String(id), 10);
      return isNaN(num) ? null : num;
    } catch {
      return null;
    }
  }

  loadUnreadMessageCountAndMap(data: any[]): void {
    const userId = this.getCurrentUserIdForMessages();
    if (!userId || !Array.isArray(data) || !data.length) return;

    const entityIds = Array.from(
      new Set(
        data
          .map(item => Number(item.id ?? item.application_id))
          .filter(id => !isNaN(id))
      )
    );
    if (!entityIds.length) return;

    this.inAppMessageService
      .getUnreadCountsForMultipleEntities(entityIds, userId)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const body = res?.body ?? res;
          const dataArr = Array.isArray(body?.data?.data)
            ? body.data.data
            : Array.isArray(body?.data)
              ? body.data
              : Array.isArray(body)
                ? body
                : [];

          // Build count map
          const countMap: Record<number, number> = {};
          dataArr.forEach((row: any) => {
            const id = Number(row?.message_entity_id);
            if (!isNaN(id)) {
              countMap[id] = Number(row?.count) || 0;
            }
          });

          // Update counts in-place for better performance
          const updateCountInData = (items: any[]) => {
            items.forEach((item: any) => {
              const id = Number(item.id ?? item.application_id);
              item.count = countMap[id] || 0;
            });
          };

          updateCountInData(this.applicationData);
          updateCountInData(this.queueData || []);
          updateCountInData(this.originalQueueData || []);

          this.cdr.markForCheck();
        },

        error: () => {
          // Fallback: initialize with 0 counts
          const initCounts = (items: any[]) => {
            items.forEach((item: any) => {
              item.count = 0;
            });
          };

          initCounts(this.applicationData);
          initCounts(this.queueData || []);
          initCounts(this.originalQueueData || []);

          this.cdr.markForCheck();
        }
      });
  }

  private notifyApplicationAssignment(applicationId: any, assignedToUserId: any, staffName: string): void {
    const payload = {
      priority: "High",
      message: `Application ${applicationId} has been assigned to you by ${staffName}.`,
      actionurl: "/pages/queues/background",
      userid: assignedToUserId,
      customformid: 1,
      isnew: true,
      isactive: true
    };

    this.fingerprintService.FingerPrintPortalnotifiction(payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error('Error while sending assignment notification');
          }
        },
        error: err => {
          console.error('Error sending assignment notification:', err);
        }
      });
  }
   private isApplicationOverdue(application: any): boolean {
    const dueDate = application?.due_date || application?.Due_Date;
    if (!dueDate) {
      return false;
    }
    try {
      const parsedDueDate = new Date(dueDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      parsedDueDate.setHours(0, 0, 0, 0);
      return parsedDueDate < today;
    } catch (error) {
      console.error('Error parsing due date:', error);
      return false;
    }
  }

  private notifyApplicationOverdue(applicationId: any, queueName: string): void {
    const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
    const userId = user?.id || user?.user_id || user?.userId;

    if (!userId) {
      console.error('Unable to send overdue notification: User ID not found');
      return;
    }

    // First notification
    const payload1 = {
      priority: "High",
      message: `Application ${applicationId} has exceeded the due date in the ${queueName} queue and requires review.`,
      actionurl: `/pages/queues/${queueName}`,
      userid: userId,
      customformid: 1,
      isnew: true,
      isactive: true
    };

    this.fingerprintService.FingerPrintPortalnotifiction(payload1)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error('Error while sending first overdue notification for application:', applicationId);
          }
        },
        error: err => {
          console.error('Error sending first overdue notification:', err);
        }
      });

    // Second notification
    const payload2 = {
      priority: "High",
      message: `Application ${applicationId} is overdue in the ${queueName} queue and requires review.`,
      actionurl: `/pages/queues/${queueName}`,
      userid: userId,
      customformid: 1,
      isnew: true,
      isactive: true
    };

    this.fingerprintService.FingerPrintPortalnotifiction(payload2)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (!res.data.success) {
            console.error('Error while sending second overdue notification for application:', applicationId);
          }
        },
        error: err => {
          console.error('Error sending second overdue notification:', err);
        }
      });
  }

  private checkAndNotifyOverdueApplications(): void {
    if (!Array.isArray(this.queueData) || this.queueData.length === 0) {
      return;
    }

    this.queueData.forEach(application => {
      if (this.isApplicationOverdue(application)) {
        const applicationId = application?.id || application?.application_id;
        if (applicationId) {
          this.notifyApplicationOverdue(applicationId, this.activeTab);
        }
      }
    });
  }

  hasAnySearchValue(): boolean {
  const form = this.searchForms && this.searchForms.first && this.searchForms.first.form;
  if (!form) return false;
  return Object.values(form.value).some((v: any) => {
    if (v === null || v === undefined || v === '') return false;
    if (Array.isArray(v)) return v.some(x => x !== null && x !== undefined && x !== '');
    return true;
  });
}
}

function formatDateToYMD(date: any): string {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

interface QueueRule {
  appStatus: string;
  bgStatus: string[];
  applicationStatus: string;
}
